import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/font.css'
import './assets/defult.css'
import { getSpace } from './api/api'
import { Base64 } from 'js-base64'
Vue.config.productionTip = false;
Vue.prototype.$getSpace = function(id) {
    getSpace({ id: id }).then(res => {
        localStorage.setItem('Space', res.data.space);
    })
};
Vue.prototype.IMAGEPATH = 'https://resources.luchuaner.com/'
import moment from "moment"
moment.locale('zh-cn');
Vue.prototype.$moment = moment;
Vue.use(ElementUI);
Vue.use(Base64)
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");